/* A short two-note chime for an incoming announcement, synthesised with
   WebAudio rather than shipped as an audio file: nothing to load, nothing
   extra in the bundle, and no chance of it failing on a cold cache at the one
   moment it's needed. */

const SOUND_KEY = 'announcementSound';

/* localStorage throws outright in some privacy modes, so every access is
   guarded — a browser that won't store the preference should still play. */
export function isChimeMuted() {
  try {
    return localStorage.getItem(SOUND_KEY) === 'off';
  } catch {
    return false;
  }
}

export function setChimeMuted(muted) {
  try {
    localStorage.setItem(SOUND_KEY, muted ? 'off' : 'on');
  } catch {
    /* Preference won't survive a reload; the toggle still works this session. */
  }
}

let ctx = null;

export function playAnnouncementChime() {
  if (isChimeMuted()) return;

  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    ctx = ctx || new Ctx();
    /* Browsers hold the context suspended until the page has been interacted
       with. resume() is a no-op once running, and rejects harmlessly on a page
       nobody has touched yet — in which case the toast carries the news alone. */
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});

    const now = ctx.currentTime;
    /* A5 then D6 — a rising fourth, which reads as "notification" rather than
       "error" without being a fanfare. */
    [[880, 0], [1174.66, 0.11]].forEach(([freq, offset]) => {
      const osc  = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      /* Ramped rather than stepped: a bare gain change clicks audibly. */
      gain.gain.setValueAtTime(0.0001, now + offset);
      gain.gain.exponentialRampToValueAtTime(0.16, now + offset + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + 0.32);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + offset);
      osc.stop(now + offset + 0.38);
    });
  } catch {
    /* Audio is a nicety — never let it break the notification path. */
  }
}
